/**
 * Cart bundle discount engine (theme-controlled line prices + optional auto_apply).
 * Config: window.shopSettings.cartBundleDiscount
 */
(function () {
  const MONEY_FORMAT =
    (window.shopSettings && window.shopSettings.moneyFormat) || '${{amount}}';

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getConfig() {
    const cfg = window.shopSettings && window.shopSettings.cartBundleDiscount;
    if (!cfg || !cfg.enabled) return null;
    return cfg;
  }

  function formatMoney(cents) {
    const value = Math.round(Number(cents) || 0);
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(value, MONEY_FORMAT);
    }
    return (value / 100).toFixed(2);
  }

  function roundCents(cents) {
    return Math.round(Number(cents) || 0);
  }

  function parseDateInTimeZone(str, timeZone) {
    if (!str || !String(str).trim()) return null;
    const raw = String(str).trim();
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (!m) return null;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    const h = Number(m[4] || 0);
    const mi = Number(m[5] || 0);
    const s = Number(m[6] || 0);
    const utcGuess = Date.UTC(y, mo - 1, d, h, mi, s);
    const fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone || 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
    const partsOf = (ms) => {
      const parts = fmt.formatToParts(new Date(ms));
      const map = {};
      parts.forEach((p) => {
        if (p.type !== 'literal') map[p.type] = p.value;
      });
      return map;
    };
    let guess = utcGuess;
    for (let i = 0; i < 3; i++) {
      const p = partsOf(guess);
      const asUtc = Date.UTC(
        Number(p.year),
        Number(p.month) - 1,
        Number(p.day),
        Number(p.hour) % 24,
        Number(p.minute),
        Number(p.second)
      );
      const desired = Date.UTC(y, mo - 1, d, h, mi, s);
      guess += desired - asUtc;
    }
    return guess;
  }

  function isWithinWindow(cfg, nowMs) {
    const tz = cfg.timeZone || 'America/New_York';
    const start = parseDateInTimeZone(cfg.start, tz);
    const end = parseDateInTimeZone(cfg.end, tz);
    if (start != null && nowMs < start) return false;
    if (end != null && nowMs > end) return false;
    return true;
  }

  function qtyMatches(op, available, required) {
    const req = Math.max(0, Number(required) || 0);
    const avail = Math.max(0, Number(available) || 0);
    if (req === 0) return true;
    switch (op) {
      case 'lte':
        return avail > 0 && avail <= req;
      case 'gte':
        return avail >= req;
      case 'eq':
      default:
        // 「等于 N」= 成套需要 N 件：剩余可分配数量 >= N 即可占用 N 件
        return avail >= req;
    }
  }

  function consumeCount(op, available, required) {
    const req = Math.max(0, Number(required) || 0);
    const avail = Math.max(0, Number(available) || 0);
    if (req === 0) return 0;
    if (op === 'lte') return Math.min(avail, req);
    return req;
  }

  function normalizeRule(rule) {
    const mainProductIds = (rule.mainProductIds || []).map(Number).filter((id) => id > 0);
    const addonQty = Math.max(0, Number(rule.addonQty) || 0);
    // addonQty 为 0 时视为「仅主商品」规则（忽略附加商品列表，避免误配导致 D 无法命中）
    const addonProductIds =
      addonQty > 0 ? (rule.addonProductIds || []).map(Number).filter((id) => id > 0) : [];
    return {
      code: String(rule.code || '').trim(),
      priority: Number(rule.priority),
      autoApply: !!rule.autoApply,
      type: rule.type === 'percentage' ? 'percentage' : 'fixed',
      value: Number(rule.value) || 0,
      mainProductIds,
      mainQtyOp: rule.mainQtyOp || 'eq',
      mainQty: Math.max(0, Number(rule.mainQty) || 0),
      addonProductIds,
      addonQtyOp: rule.addonQtyOp || 'eq',
      addonQty,
      needsAddon: addonQty > 0 && addonProductIds.length > 0,
      mainOnly: addonQty <= 0 || addonProductIds.length === 0,
    };
  }

  function expandUnits(items) {
    const units = [];
    (items || []).forEach((item, lineIndex) => {
      const qty = Number(item.quantity) || 0;
      if (qty <= 0) return;
      const linePrice =
        Number(item.original_line_price != null ? item.original_line_price : item.final_line_price) || 0;
      const unitPrice = Math.round(linePrice / qty);
      const lineKey = String(item.key || item.id || `line-${lineIndex}`);
      for (let i = 0; i < qty; i++) {
        units.push({
          key: `${lineKey}#${i}`,
          lineKey,
          productId: Number(item.product_id),
          variantId: Number(item.variant_id),
          unitPrice,
          used: false,
        });
      }
    });
    return units;
  }

  function pickUnits(pool, productIds, count) {
    if (count <= 0) return [];
    const orderIndex = new Map();
    (productIds || []).forEach((id, idx) => orderIndex.set(Number(id), idx));

    const candidates = pool
      .filter((u) => !u.used && orderIndex.has(u.productId))
      .sort((a, b) => {
        const oa = orderIndex.get(a.productId);
        const ob = orderIndex.get(b.productId);
        if (oa !== ob) return oa - ob;
        // 同品多规格：优先占用更贵的
        if (b.unitPrice !== a.unitPrice) return b.unitPrice - a.unitPrice;
        return String(a.key).localeCompare(String(b.key));
      });

    if (candidates.length < count) return [];
    return candidates.slice(0, count);
  }

  function calcAwardAmount(rule, takenUnits) {
    const subtotal = takenUnits.reduce((sum, u) => sum + u.unitPrice, 0);
    const rawValue = Number(rule.value) || 0;
    let amount = 0;
    if (rule.type === 'percentage') {
      amount = (subtotal * rawValue) / 100;
    } else {
      amount = rawValue * 100;
      amount = Math.min(amount, subtotal);
    }
    return roundCents(amount);
  }

  /** 固定额按价款占比分摊；百分比按同比例落到各 unit（分摊误差补到最后一件） */
  function distributeAmountToUnits(amount, takenUnits) {
    const total = takenUnits.reduce((s, u) => s + u.unitPrice, 0);
    if (!takenUnits.length || amount <= 0) {
      return takenUnits.map((u) => ({ lineKey: u.lineKey, discount: 0, unitPrice: u.unitPrice }));
    }
    if (total <= 0) {
      const each = Math.floor(amount / takenUnits.length);
      let rest = amount - each * takenUnits.length;
      return takenUnits.map((u, i) => ({
        lineKey: u.lineKey,
        unitPrice: u.unitPrice,
        discount: each + (i < rest ? 1 : 0),
      }));
    }
    const parts = [];
    let allocated = 0;
    takenUnits.forEach((u, i) => {
      let share;
      if (i === takenUnits.length - 1) {
        share = amount - allocated;
      } else {
        share = Math.floor((amount * u.unitPrice) / total);
        allocated += share;
      }
      parts.push({ lineKey: u.lineKey, unitPrice: u.unitPrice, discount: share });
    });
    return parts;
  }

  function tryApplyOnce(rule, pool) {
    if (!rule.mainProductIds.length || rule.mainQty <= 0) return null;

    const mainAvail = pool.filter((u) => !u.used && rule.mainProductIds.includes(u.productId)).length;
    if (!qtyMatches(rule.mainQtyOp, mainAvail, rule.mainQty)) return null;

    let addonAvail = 0;
    if (rule.needsAddon) {
      addonAvail = pool.filter((u) => !u.used && rule.addonProductIds.includes(u.productId)).length;
      if (!qtyMatches(rule.addonQtyOp, addonAvail, rule.addonQty)) return null;
    }

    const mainNeed = consumeCount(rule.mainQtyOp, mainAvail, rule.mainQty);
    const addonNeed = rule.needsAddon ? consumeCount(rule.addonQtyOp, addonAvail, rule.addonQty) : 0;

    const mainTaken = pickUnits(pool, rule.mainProductIds, mainNeed);
    if (mainTaken.length !== mainNeed) return null;
    const addonTaken = rule.needsAddon ? pickUnits(pool, rule.addonProductIds, addonNeed) : [];
    if (rule.needsAddon && addonTaken.length !== addonNeed) return null;

    const taken = mainTaken.concat(addonTaken);
    taken.forEach((u) => {
      u.used = true;
    });

    const amount = calcAwardAmount(rule, taken);
    const unitParts = distributeAmountToUnits(amount, taken);
    return {
      code: rule.code,
      amount,
      autoApply: rule.autoApply,
      type: rule.type,
      units: unitParts,
    };
  }

  function allocateMatches(cart, cfg) {
    const rules = (cfg.rules || [])
      .map(normalizeRule)
      .filter((r) => r.code && r.mainProductIds.length)
      .sort((a, b) => {
        const pa = Number.isFinite(a.priority) ? a.priority : 999;
        const pb = Number.isFinite(b.priority) ? b.priority : 999;
        if (pa !== pb) return pa - pb;
        return String(a.code).localeCompare(String(b.code));
      });

    const bundleRules = rules.filter((r) => !r.mainOnly);
    const mainOnlyRules = rules.filter((r) => r.mainOnly);
    const pool = expandUnits(cart.items || []);
    const awards = [];

    // Phase 1: 带附加商品的组合（每轮每条规则最多一次，多轮消化余量）
    let progress = true;
    let guard = 0;
    while (progress && guard++ < 40) {
      progress = false;
      for (let i = 0; i < bundleRules.length; i++) {
        const award = tryApplyOnce(bundleRules[i], pool);
        if (award) {
          awards.push(award);
          progress = true;
        }
      }
    }

    // Phase 2: 仅主商品规则（如 Bundle D）—— 在组合规则占完后，把剩余主商品继续拆完
    progress = true;
    guard = 0;
    while (progress && guard++ < 40) {
      progress = false;
      for (let i = 0; i < mainOnlyRules.length; i++) {
        const award = tryApplyOnce(mainOnlyRules[i], pool);
        if (award) {
          awards.push(award);
          progress = true;
        }
      }
    }

    const lineDiscountMap = {};
    awards.forEach((award) => {
      (award.units || []).forEach((u) => {
        if (!u.lineKey) return;
        lineDiscountMap[u.lineKey] = (lineDiscountMap[u.lineKey] || 0) + (u.discount || 0);
      });
    });

    const totalDiscount = roundCents(awards.reduce((s, a) => s + a.amount, 0));
    const itemsSubtotal =
      cart.items_subtotal_price != null
        ? Number(cart.items_subtotal_price)
        : (cart.items || []).reduce(
            (s, it) => s + (Number(it.original_line_price) || Number(it.final_line_price) || 0),
            0
          );

    return {
      awards,
      totalDiscount,
      itemsSubtotal,
      payable: Math.max(0, itemsSubtotal - totalDiscount),
      lineDiscountMap,
      codesToApply: awards.filter((a) => a.autoApply).map((a) => a.code),
    };
  }

  function hideFooterDiscountLists() {
    document.querySelectorAll('[data-cart-bundle-discount-list]').forEach((list) => {
      list.innerHTML = '';
      list.hidden = true;
    });
    // 插件也可能往 .taxes-discounts 里塞折扣行；功能开启时统一隐藏
    document.querySelectorAll('.taxes-discounts .discounts').forEach((list) => {
      list.hidden = true;
      list.style.display = 'none';
    });
  }

  function formatSubtotalMoney(cents, withCurrency) {
    const money = formatMoney(cents);
    if (withCurrency && window.shopSettings && window.shopSettings.isoCode) {
      return `${money} ${window.shopSettings.isoCode}`;
    }
    return money;
  }

  function renderSubtotals(result) {
    const cfg = getConfig();
    const showSubtotalDiscount = !!(cfg && cfg.showSubtotalDiscount);
    document.querySelectorAll('[data-cart-bundle-discount-subtotal]').forEach((el) => {
      if (!result) return;
      const withCurrency = el.getAttribute('data-with-currency') === 'true';
      const itemsSubtotal = Number(result.itemsSubtotal) || 0;
      const payable = Number(result.payable) || 0;
      const hasDiscount = showSubtotalDiscount && result.totalDiscount > 0 && payable < itemsSubtotal;

      if (hasDiscount) {
        // 总价区：红色斜划线原价 + 折后价（与商品行一致，不展示折扣码）
        el.innerHTML =
          `<span class="cart-bundle-discount-subtotal__compare">${formatSubtotalMoney(
            itemsSubtotal,
            withCurrency
          )}</span>` +
          `<span class="cart-bundle-discount-subtotal__final">${formatSubtotalMoney(
            payable,
            withCurrency
          )}</span>`;
        el.classList.add('cart-bundle-discount-subtotal--compare');
      } else {
        el.innerHTML = formatSubtotalMoney(payable, withCurrency);
        el.classList.remove('cart-bundle-discount-subtotal--compare');
      }
    });
  }

  function buildComparePriceHtml(originalCents, finalCents) {
    return (
      `<dl class="price-item--compare">` +
      `<dd class="price"><s class="price-item--regular"><price-money><bdi>${formatMoney(
        originalCents
      )}</bdi></price-money></s></dd>` +
      `<dd class="price"><price-money><bdi>${formatMoney(finalCents)}</bdi></price-money></dd>` +
      `</dl>`
    );
  }

  function buildPlainPriceHtml(cents) {
    return `<dd class="price"><price-money><bdi>${formatMoney(cents)}</bdi></price-money></dd>`;
  }

  function renderLinePrices(result, cart) {
    const map = (result && result.lineDiscountMap) || {};
    const itemsByKey = {};
    ((cart && cart.items) || []).forEach((item) => {
      const lineKey = String(item.key || item.id || '');
      if (lineKey) itemsByKey[lineKey] = item;
    });

    document.querySelectorAll('[data-cart-bundle-line-price]').forEach((mount) => {
      const lineKey = String(mount.getAttribute('data-line-key') || '');
      if (!lineKey) return;
      const item = itemsByKey[lineKey];
      const qty = Number(mount.getAttribute('data-qty') || (item && item.quantity) || 1) || 1;
      const unitOriginal =
        Number(mount.getAttribute('data-unit-price')) ||
        (item && Number(item.original_price)) ||
        0;
      const originalLine = unitOriginal * qty;
      const lineDiscount = roundCents(map[lineKey] || 0);
      const unitDiscount = Math.round(lineDiscount / qty);
      const unitFinal = Math.max(0, unitOriginal - unitDiscount);
      const lineFinal = Math.max(0, originalLine - lineDiscount);
      const mode = mount.getAttribute('data-price-mode') || 'unit';
      const isMainCart = !!mount.closest('.cart-item__price-wrapper');

      if (lineDiscount > 0) {
        if (isMainCart) {
          const showOriginal = mode === 'line' ? originalLine : unitOriginal;
          const showFinal = mode === 'line' ? lineFinal : unitFinal;
          mount.innerHTML =
            `<dl class="cart-item__discounted-prices">` +
            `<dd class="price--on-sale"><s class="price price-item--regular price--end"><price-money><bdi>${formatMoney(
              showOriginal
            )}</bdi></price-money></s></dd>` +
            `<dd class="price price--end"><price-money><bdi>${formatMoney(
              showFinal
            )}</bdi></price-money></dd>` +
            `</dl>`;
        } else {
          mount.innerHTML = buildComparePriceHtml(unitOriginal, unitFinal);
        }
      } else if (isMainCart) {
        const showOriginal = mode === 'line' ? originalLine : unitOriginal;
        mount.innerHTML = `<span class="price price--end"><price-money><bdi>${formatMoney(
          showOriginal
        )}</bdi></price-money></span>`;
      } else {
        mount.innerHTML = buildPlainPriceHtml(unitOriginal);
      }
    });
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function renderDiscountUI(result, cart) {
    hideFooterDiscountLists();
    renderSubtotals(result);
    renderLinePrices(result, cart);
  }

  let lastAppliedSignature = '';

  async function syncDiscountCodes(codes) {
    const signature = (codes || []).slice().sort().join(',').toLowerCase();
    if (signature === lastAppliedSignature) return;
    try {
      await fetch(`${getRoot()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: codes && codes.length ? codes.join(',') : '' }),
      });
      lastAppliedSignature = signature;
    } catch (e) {
      // ignore
    }
  }

  async function fetchCart() {
    return fetch(`${getRoot()}cart.js`, { credentials: 'same-origin' }).then((r) => r.json());
  }

  async function refresh(options) {
    const opts = options || {};
    const cfg = getConfig();
    if (!cfg) return null;

    let cart = opts.cart || null;
    if (!cart) {
      try {
        cart = await fetchCart();
      } catch (e) {
        return null;
      }
    }

    const itemsSubtotal =
      cart.items_subtotal_price != null
        ? Number(cart.items_subtotal_price)
        : (cart.items || []).reduce(
            (s, it) => s + (Number(it.original_line_price) || Number(it.final_line_price) || 0),
            0
          );

    if (!isWithinWindow(cfg, Date.now())) {
      const empty = {
        awards: [],
        totalDiscount: 0,
        itemsSubtotal,
        payable: itemsSubtotal,
        lineDiscountMap: {},
        outOfWindow: true,
        codesToApply: [],
      };
      renderDiscountUI(empty, cart);
      if (!opts.skipApply) {
        const anyAuto = (cfg.rules || []).some((r) => r.autoApply);
        if (anyAuto) await syncDiscountCodes([]);
      }
      return empty;
    }

    const result = allocateMatches(cart, cfg);
    renderDiscountUI(result, cart);

    if (!opts.skipApply && result.codesToApply && result.codesToApply.length) {
      const unique = [];
      result.codesToApply.forEach((c) => {
        if (!unique.includes(c)) unique.push(c);
      });
      await syncDiscountCodes(unique);
    } else if (!opts.skipApply) {
      const anyAutoRule = (cfg.rules || []).some((r) => r.autoApply);
      if (anyAutoRule) await syncDiscountCodes([]);
    }

    window.__cartBundleDiscountResult = result;
    document.dispatchEvent(new CustomEvent('cart-bundle-discount:updated', { detail: result }));
    return result;
  }

  window.CartBundleDiscount = {
    refresh,
    allocateMatches,
    isWithinWindow,
    renderDiscountUI,
    formatMoney,
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (getConfig()) {
      refresh({ skipApply: false }).catch(() => {});
    }
  });
})();
